<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- titulo y boton crear -->
    <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse pt-0">
        <TableButtonComp
          textButton="Crear Usuario"
          iconBut="fas fa-plus"
          normalButton
          @click="addItem()"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <ComundataTableComp
          placeholderTextsearch="Buscar usuarios"
          :items="Usuarios"
          :headers="GestionusuariosHeaders"
          rowsPerPageText="Usuarios por página:"
          noResultsText="Sin usuarios por mostrar:"
          whitSearch
        >
          <slot>
            <!-- Consultas de la tabla -->

            <v-row dense>
              <v-col cols="12" md="6" sm="6">
                <AutocompleteComp
                  v-model="filtros.id_colegio"
                  textLabel="Colegio"
                  :items="colegios"
                  @change="changeColegio()"
                  item-text="nombre_colegio"
                  item-value="id"
                  :rules="[rul.selectReq, rul.required]"
                />
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <AutocompleteComp
                  v-model="filtros.id_perfil"
                  textLabel="Perfil"
                  :items="perfiles"
                  @change="loadMain()"
                  item-text="descripcion_perfil"
                  item-value="id"
                />
              </v-col>
            </v-row>
          </slot>

          <template v-slot:nombre_usuario="{ item }">
            <div>
              {{
                item.nombre_persona +
                " " +
                item.ape1_persona +
                " " +
                item.ape2_persona
              }}
            </div>
          </template>

          <template v-slot:master_ck1_valor="{ item }">
            <v-chip
              small
              :class="
                item.master_ck1_valor === 'si'
                  ? 'color_activo'
                  : 'color_inactivo'
              "
            >
              {{ item.master_ck1_valor === "si" ? "Si" : "No" }}
            </v-chip>
          </template>

          <template v-slot:estado_usuario="{ item }">
            <v-chip
              small
              :class="
                item.estado_usuario === 1 ? 'color_activo' : 'color_inactivo'
              "
            >
              {{ item.estado_usuario === 1 ? "Activo" : "Inactivo" }}
            </v-chip>
          </template>

          <template v-slot:action_editar="{ item }">
            <TableButtonComp
              v-if="componenteEvento.editar_submodulo"
              tooltipText="Editar Usuario"
              editButton
              @click="editItem(item)"
            />
          </template>

          <template v-slot:action_borrar="{ item }">
            <TableButtonComp
              v-if="componenteEvento.borrar_submodulo"
              :disabled="datoLogin.id == item.id"
              tooltipText="Borrar Usuario"
              deleteButton
              @click="deleteUsuario(item.id)"
            />
          </template>
        </ComundataTableComp>
      </v-col>
    </v-row>

    <!-- /////////////////////////////////////////////////////////////////
                                                                 //         MODAL VERIFICAR SI EXISTE DOCUMENTO EN PERSONAS      //
                                                            ////////////////////////////////////////////////////////////////    -->
    <v-form ref="formDatosValidar" lazy-validation>
      <v-dialog v-model="dialogValidar" persistent scrollable max-width="350px">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row>
              <v-col cols="10">
                    <label class="label-extendido">Verificar número de <br>documento</label>
                  </v-col>

              <v-col cols="2" class="d-flex flex-row-reverse">
                <v-btn
                  fab
                  dark
                  x-small
                  class="btn_style3"
                  @click="dialogValidar = false"
                  ><v-icon dark>fa-times</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="documento_validar"
                  label="Número de documento"
                  :rules="[rul.required, rul.min4, rul.max12]"
                  @keypress="restrictCharsNumeros($event)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_style3" dark  @click="dialogValidar = false"
              >Cancelar</v-btn
            >

            <v-btn class="btn_block_style2" dark  @click="validarDoc"
              >Validar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal de verificación de documento  -->

    <v-form ref="formUsuarios" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="75%">
        <v-card>
          <v-card-title class="btn_otro">
            <label>{{ formTitle }}</label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog = false"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="pb-0">
                <v-alert
                  dense
                  border="left"
                  class="text-center"
                  color="#0277bd"
                  dark
                >
                  <h3>Datos personales</h3>
                </v-alert>
              </v-col>
              <v-col cols="12" sm="12" md="9" xs="12">
                <v-row>
                  <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                    <v-text-field
                      label="Nombres"
                      type="text"
                      v-model="datos.nombre_persona"
                      :rules="[rul.required, rul.max50]"
                      :readonly="bloquearInput"
                      @keypress="restrictCharsLetras($event)"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                    <v-text-field
                      label="Apellido paterno"
                      type="text"
                      v-model="datos.ape1_persona"
                      :rules="[rul.required, rul.max40]"
                      @keypress="restrictCharsLetras($event)"
                      :readonly="bloquearInput"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                    <v-text-field
                      label="Apellido materno"
                      type="text"
                      v-model="datos.ape2_persona"
                      :rules="[rul.required, rul.max40]"
                      @keypress="restrictCharsLetras($event)"
                      :readonly="bloquearInput"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                    <v-select
                      label="Tipo de documento"
                      v-model="datos.id_tipo_documento"
                      :items="TipoDocumentos"
                      item-value="id"
                      item-text="desc_tipo_documento"
                      :rules="[rul.selectReq]"
                      :readonly="bloquearInput"
                      @change="seleccionarTipoDocumento"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                    <v-text-field
                      label="Número de documento"
                      v-model="datos.numdoc_persona"
                      :rules="[
                        rul.required,
                        rul.min4,
                        rul.max12,
                        validarNumeroDocumento,
                      ]"
                      @keypress="restrictCharsNumeros($event)"
                      :readonly="bloquearInput"
                      autofocus
                      ref="refNumeroDocumento"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                    <v-select
                      label="Sexo"
                      v-model="datos.sexo_persona"
                      :items="sexos"
                      item-value="abbr"
                      item-text="nombre"
                      :rules="[rul.selectReq]"
                      :readonly="bloquearInput"
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </v-col>

              <!--  Avatar de Persona actualizado 2020/07/06 -->
              <v-col
                cols="12"
                sm="12"
                md="3"
                xs="12"
                class="d-flex justify-center order-first order-md-0"
              >
                <v-avatar size="116" hover @click="pickAvatar">
                  <v-icon
                    v-if="!avatar.state && !previewImgAvatar"
                    class="fondo_add_img"
                    dark
                    size="80"
                    >fas fa-user</v-icon
                  >
                  <img
                    v-if="avatar.state && !previewImgAvatar"
                    :src="avatar.url"
                    class="fondo_add_img"
                    dark
                    size="100"
                  />
                  <img
                    v-if="previewImgAvatar"
                    :src="previewImgAvatar"
                    class="fondo_add_img"
                    dark
                    size="100"
                  />

                  <input
                    type="file"
                    style="display: none"
                    ref="imageAvatar"
                    accept=".jpg, .png, .gif"
                    @change="onFileAvatar"
                  />
                </v-avatar>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Fecha de Nacimiento"
                      v-on="on"
                      :rules="[rul.required]"
                      readonly
                    >
                    </v-text-field>
                  </template>

                  <v-date-picker
                    v-model="datos.fecnac_persona"
                    no-title
                    @input="menu2 = false"
                    :disabled="bloquearInput"
                    :max="getEndDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-autocomplete
                  v-model="datos.id_pais_nacimiento"
                  :items="Paises"
                  item-text="nombre_pais"
                  item-value="id"
                  :rules="[rul.selectReq]"
                  label="País de Nacimiento"
                  :readonly="bloquearInput"
                  @change="getNacionalidades(datos.id_pais_nacimiento)"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-autocomplete
                  label="Nacionalidad"
                  v-model="datos.id_pais_nacimiento"
                  :items="Nacionalidades"
                  item-text="desc_nacionalidad"
                  item-value="id"
                  :rules="[rul.selectReq]"
                  :readonly="bloquearInput"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="4" lg="3" class="py-0">
                  <v-radio-group class="mt-0" v-model="datos.estado_usuario" label="Estado:">
                    <v-radio label="Activo" :value="1" color="teal" />
                    <v-radio label="Inactivo" :value="0" color="error" />
                  </v-radio-group>
              </v-col>

              <!--
                <v-col cols="12" sm="4" md="4" lg="3" class="pb-0"  >
                <v-radio-group v-model="datos.master_ck1" row label="Web Master Clicken 1" class="pa-0" disabled="true">
                <v-radio :label="`Si`" :value="1" color="teal"></v-radio>
                <v-radio :label="`No`" :value="0" color="error"></v-radio>
                </v-radio-group>
                </v-col>
              -->

              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-alert
                  dense
                  border="left"
                  class="text-center"
                  color="#0277bd"
                  dark
                >
                  <h3>Datos de usuario</h3>
                </v-alert>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                <v-text-field
                  label="Nombre de Usuario"
                  v-model="datos.usu_usuario"
                  type="text"
                  :rules="[rul.required, rul.max40]"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="4"
                class="py-0"
                v-if="this.evento == 'agregar'"
              >
                <v-text-field
                  label="Contraseña"
                  v-model="datos.password_usuario"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                  :rules="[rul.max20]"
                  class="input-group--focused"
                  @click:append="show = !show"
                >
                </v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="4"
                class="py-0"
                v-if="!habilitarUsMaster"
              >
                <v-select
                  v-model="datos.id_perfil"
                  @change="cargarLicenciaTipo(datos.id_perfil)"
                  :items="Perfil"
                  item-text="descripcion_perfil"
                  item-value="id"
                  :rules="[rul.selectReq]"
                  label="Perfil"
                >
                </v-select>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="4"
                clas="py-0"
                v-if="!habilitarUsMaster"
              >
                <v-select
                  class="py-0"
                  label="Tipo de Licencia"
                  v-model="datos.id_licencia_tipo"
                  :items="LicenciaTipo"
                  @change="cargarLicencia"
                  item-value="id"
                  item-text="desc_tipo_licencia"
                  :readonly="
                    datos.fecha_fin > new Date().toISOString().substr(0, 10)
                  "
                  :rules="[rul.selectReq]"
                >
                </v-select>
              </v-col>

              <template v-if="!habilitarUsMaster">
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  class="py-0"
                  v-if="
                    datos.fecha_fin > new Date().toISOString().substr(0, 10)
                  "
                >
                  <div class="px-4">
                    <label>Licencia:</label>
                    <p class="black--text">{{ datos.serie_licencia }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4" class="py-0" v-else>
                  <v-autocomplete
                    label="Licencias"
                    v-model="datos.id_licencia"
                    :items="Licencia"
                    item-value="id"
                    item-text="serie_licencia"
                    :rules="[rul.selectReq]"
                  >
                  </v-autocomplete>
                </v-col>
              </template>

              <!-- fin de usuarios -->
              <!-- ubicacion usuarios -->

              <v-col cols="12" sm="12" md="12" class="pb-0">
                <v-alert
                  dense
                  border="left"
                  class="text-center"
                  color="#0277bd"
                  dark
                >
                  <h3>Datos de ubicación y contacto</h3>
                </v-alert>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-autocomplete
                  label="Departamento"
                  v-model="datos.id_ubicacion1"
                  :items="Ubicacion1"
                  item-text="nombre_ubicacion1"
                  item-value="id"
                  @change="loadUbicacion2(datos.id_ubicacion1)"
                  :rules="[rul.selectReq]"
                  :readonly="bloquearInput"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-autocomplete
                  label="Provincia"
                  v-model="datos.id_ubicacion2"
                  :items="Ubicacion2"
                  item-value="id"
                  item-text="nombre_ubicacion2"
                  @change="loadUbicacion3(datos.id_ubicacion2)"
                  :rules="[rul.selectReq]"
                  :readonly="bloquearInput"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-autocomplete
                  label="Distrito"
                  v-model="datos.id_ubicacion3"
                  :items="Ubicacion3"
                  item-text="nombre_ubicacion3"
                  item-value="id"
                  :rules="[rul.selectReq]"
                  :readonly="bloquearInput"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-text-field
                  label="Teléfono"
                  v-model="datos.telf_persona"
                  type="number"
                  min="1"
                  @keypress="restrictCharsNumeros($event)"
                  :rules="[rul.max12]"
                  :readonly="bloquearInput"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-text-field
                  label="Correo Electrónico"
                  v-model="datos.correo_persona"
                  type="email"
                  :rules="[rul.email_null, rul.max50]"
                  :readonly="bloquearInput"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-text-field
                  label="Dirección"
                  v-model="datos.direc_persona"
                  :rules="[rul.max150]"
                  :readonly="bloquearInput"
                ></v-text-field>
              </v-col>
              <!-- fin ubicacion usuarios -->
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_style3" dark  @click="dialog = false"
              >Cancelar</v-btn
            >

            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento == 'editar'"
              @click="saveItem()"
              >Guardar Cambios</v-btn
            >
            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento == 'agregar'"
              @click="saveItem()"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <!-- confirm on delete -->
    <confirm
      @aceptar="deleted"
      @cancelar="clear_confirm"
      :title="confirm.title"
      :active="confirm.active"
    />
  </div>
</template>

<script>
import axios, { API_URL } from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { GestionusuariosHeaders } from "../../helpers/headersTable.js";
import ComundataTableComp from "../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../components/ComponentsEst/AutocompleteComp.vue";

export default {
  components: {
    ComundataTableComp,
    TableButtonComp,
    AutocompleteComp,
  },

  data: (vm) => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 3, id_modulo: 4 }, //sud_modulo y modulo
    GestionusuariosHeaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "" || value == null) {
          return "Campo Requerido";
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },

    /// modal delete confirm
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    // consulta principal
    search: "",
    Usuarios: [],

    ///////////////////////////////////

    // modal verificar si existe numero documento persona
    dialogValidar: false,
    bloquearInput: false,
    documento_validar: null,
    respuestaValidDoc: [],
    //////////////////////////////////////

    //-- funciones del date picker de fecha
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,

    // modal agregar editar usuario
    evento: null,
    dialog: false,
    formTitle: null,
    datos: {},
    filtros: {},
    //---------validacion password--
    show: false,

    //--------sexo------------------
    sexos: [
      { nombre: "Masculino", abbr: "M" },
      { nombre: "Femenino", abbr: "F" },
    ],

    //----- Colegio -----
    colegios: [],
    Colegio: [],
    TipoDocumentos: [],

    perfiles: [],
    Perfil: [],
    Licencia: [],
    LicenciaTipo: [],

    Paises: [],
    Nacionalidades: [],

    // avatar usuario
    avatar: {
      url: null,
      state: false,
    },

    //-------Departamentos-----------
    Ubicacion1: [],
    //-------provincias--------------
    Ubicacion2: [],
    //-------Distritos--------------
    Ubicacion3: [],

    // Avatar  Persona imagen
    previewImgAvatar: "",
    imageSaveAvatar: "",
    rutaServer: `${API_URL}`,
    // rutaServer: 'http://localhost:5000/',

    // END Avatar  //////////////////////////////////////////////
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    /*
            provinciasFilter(){
                return this.Provincias.filter((data)=>data.id.includes(this.datos.id_departamento));
            }
            */

    // Maxima Fecha Calendario
    getEndDate() {
      return new Date().toISOString().substr(0, 10);
    },

    computedDateFormatted() {
      return this.formatDate(this.datos.fecnac_persona);
    },

    // AVATAR PARA USUARIOS //
    avatarImg() {
      if (this.datos.ruta_avatar_persona) {
        return (
          this.rutaServer +
          this.datos.ruta_avatar_persona +
          this.datos.avatar_persona
        );
      } else {
        return null;
      }
    },

    habilitarUsMaster() {
      if (this.datos.master_ck1 == 1) {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    // this.loadMain();
    this.getAllColegios();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////
    validarNumeroDocumento(numDoc) {
      let msg = "";

      switch (this.datos.id_tipo_documento) {
        case 1:
          if (isNaN(numDoc)) {
            msg = "solo debe tener números";
          } else if (numDoc.length != 8) {
            msg = "solo debe tener 8 dígitos";
          }
          break;

        case 2:
          if (numDoc.length > 15) {
            msg = "debe tener menos de 15 dígitos";
          }
          break;
        case 4:
          if (isNaN(numDoc)) {
            msg = "solo debe tener números";
          } else if (numDoc.length != 11) {
            msg = "solo debe tener 11 dígitos";
          }
          break;
        default:
          msg = "";
      }
      //console.log('MSG', msg)
      return msg != "" ? msg : true;
    },
    // obtener y validar que existe la imagen
    async get_avatar() {
      if (!this.datos.avatar_persona) return null;

      const url = `${this.rutaServer}archivo/avatar/${this.datos.id_colegio}/${this.datos.avatar_persona}`;
      const { data } = await axios.get(url);
      this.avatar.state = data.success;
      this.avatar.url = `${this.rutaServer}${this.datos.ruta_avatar_persona}${this.datos.avatar_persona}`;
    },

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    seleccionarTipoDocumento() {
      this.$refs.refNumeroDocumento.validate();
    },
    async getNacionalidades(idPais) {
      let response = await axios.get(
        "/sistema/usuarioManager/getNacionalidades/" + idPais
      );

      let data = response.data;


      if (data.messageT == "S") {
        this.Nacionalidades = data.payload;
        this.datos.id_nacionalidad = this.Nacionalidades[0].id;
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se encontró nacionalidades.",
          tiempo: null,
        });
      }

      //console.log("nacionalidades",response.data)
    },

    //-------cargar registros------------
    async loadMain() {
      try {
        let query = `?id_colegio=${Number(this.filtros.id_colegio)}&id_perfil=${
          this.filtros.id_perfil
        }`;
        let { data } = await axios.get(
          `/sistema/usuarioManager/getMain/${query}`
        );
        this.Usuarios = data.payload;
        //console.log(this.Usuarios)
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },
    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },
    async limpiarForm() {
      let dataForm = {
        id: 0,
        id_persona: 0,
        id_colegio: 0,
        id_tipo_documento: 0,
        master_ck1: 0,
        id_perfil: 0,
        numdoc_persona: "",
        ape1_persona: null,
        ape2_persona: null,
        nombre_persona: null,
        sexo_persona: "",
        fecnac_persona: "",
        id_nacionalidad: 0,
        id_pais_nacimiento: 0,
        id_pais: 0,
        id_ubicacion1: 0,
        id_ubicacion2: 0,
        id_ubicacion3: 0,
        telf_persona: "",
        correo_persona: "",
        direc_persona: "",
        avatar_persona: "",
        ruta_avatar_persona: null,
        estado_persona: 0,
        id_usuario: this.datoLogin.id,
        id_licencia_tipo: 0,
        fecha_fin: null,
        usu_usuario: "",
        password_usuario: null,
        estado_usuario: 1,
        id_licencia: null,
      };
      this.clear_confirm();

      this.datos = dataForm;

      this.resetValidation();
      this.previewImgAvatar = null;
    },

    resetValidation() {
      this.$refs.formUsuarios.resetValidation();
    },

    async addItem() {
      this.$refs.formDatosValidar.resetValidation();
      this.dialogValidar = true;
      this.documento_validar = null;

      this.loadPerfil(this.datoLogin.id_colegio);
    },

    changeColegio() {
      delete this.filtros.id_perfil;
      this.getPerfiles(this.filtros.id_colegio);
    },

    async validarDoc() {
      if (this.$refs.formDatosValidar.validate()) {
        this.limpiarForm();
        await this.getQuery();

        try {
          let response = await axios.get(
            "/sistema/usuarioManager/validarDocumento/Documento/" +
              this.documento_validar +
              "/colegio/" +
              this.datoLogin.id_colegio +
              "/usuario/" +
              this.datoLogin.id
          );
          this.respuestaValidDoc = response.data.payload;
          //console.log(this.respuestaValidDoc);

          if (this.respuestaValidDoc != null) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: "Existe información asociada a este Número de documento",
              tiempo: null,
            });
            this.bloquearInput = false;
            this.datos = this.respuestaValidDoc;
            this.datos.master_ck1 = 0;
            this.datos.estado_usuario = 0;
            //this.datos.usu_usuario = this.respuestaValidDoc.numdoc_persona + - + this.respuestaValidDoc.id_colegio

            //this.datos.id = 0
            this.datos.id_persona = this.respuestaValidDoc.id;
            this.datos.id_usuario = this.datoLogin.id;
            (this.datos.id_licencia = 0),
              await this.loadUbicacion1(this.respuestaValidDoc.id_pais);
            await this.loadUbicacion2(this.respuestaValidDoc.id_ubicacion1);
            await this.loadUbicacion3(this.respuestaValidDoc.id_ubicacion2);
          } else {
            this.setEnviarMens({
              tipo: "W",
              mensaje:
                "No existe información asociada a este ''Número de documento''",
              tiempo: null,
            });
            this.bloquearInput = false;
            this.datos.numdoc_persona = this.documento_validar;
          }

          this.datos.usu_usuario = `${this.datos.numdoc_persona}-${this.datoLogin.id_colegio}`;

          this.dialogValidar = false;

          this.dialog = true;
          this.evento = "agregar";
          this.formTitle = "Crear usuario";
          this.bloquearInput = false;
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          //console.log(error);
        }
      }
    },

    //---------obtener datos pára editar
    async editItem(item) {
      this.bloquearInput = false;
      this.dialog = true;
      this.evento = "editar";
      this.formTitle = "Editar Usuario";
      this.limpiarForm();

      await this.getQuery();
      this.datos = Object.assign({}, item);

      //console.log(item);

      this.datos.password_usuario = "";

      this.cargarLicenciaTipo(item.id_perfil);
      this.loadPerfil(item.id_colegio);
      this.get_avatar();
      await this.getNacionalidades(item.id_pais_nacimiento);
      await this.loadUbicacion1(item.id_pais);
      await this.loadUbicacion2(item.id_ubicacion1);
      await this.loadUbicacion3(item.id_ubicacion2);
      //console.log("ITEM", item)
    },

    async saveItem() {
      if (this.$refs.formUsuarios.validate()) {
        try {
          //let params = this.datos
          this.datos.id_usuario = this.datoLogin.id;
          this.datos.id_nacionalidad = this.datos.id_pais_nacimiento;
          this.datos.evento = this.evento;
          let res
          if (this.evento == "agregar") {
            let arrColegio = this.Colegio.filter((element) => element.id == this.datos.id_colegio)
            this.datos.id_pais = arrColegio[0].id_pais;
            //console.log(` VALOR A FILTAR: ${JSON.stringify(this.datos.id_colegio)} DATOS PAIS  ${JSON.stringify(this.datos.id_pais)}, ID PAIS  ${JSON.stringify(arrColegio[0].id_pais)}`);
            res = await axios.post("/sistema/usuarioManager/", this.datos);
            this.datos.id_persona = res.data.payload.id_personal;
          }
          else if (this.evento == "editar") {
            res = await axios.put("/sistema/usuarioManager/" + this.datos.id,this.datos);
          }

          // si existe una imagen preview y la imagen a enviar al servidor, Guarda el avatar
          // SAVE AVATAR

          if (this.previewImgAvatar && this.imageSaveAvatar) {
            await this.saveAvatar();
          }
          
          // SI RES EXISTE Y TIENE DATA Y SU PROPIEDAD MESSAGET ES IGUAL A "S" 
          // SIGNIFICA QUE GUARDÓ O REGISTRÓ CORRECTAMENTE, en caso no irá al catch
          if (res.data.messageT === "S") {
            this.loadMain();
            this.dialog = false;
            this.limpiarForm();
            this.setEnviarMens({
            tipo: `${res.data.messageT}`,
            mensaje: `${res.data.message}`,
            tiempo: 6000,
          });
          }

        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    // guardar imagen
    async saveAvatar() {
      let formData = new FormData();
      formData.append("subirArchivo", this.imageSaveAvatar);
      formData.append("id_colegio", this.datos.id_colegio);
      formData.append("id_usuario", this.datoLogin.id);
      formData.append("id_persona", this.datos.id_persona);

      const img = document.getElementById("avatar-user-profile");
      await axios
        .post("archivo/avatarPersona", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          /* console.log("datos:",this.datos)
           */
          //console.log("res:",res)
          const url = this.rutaServer + res.data.uri + res.data.nombreArchivo;

          if(img){
            img.style.backgroundImage = `url(${url})`;
          }
          this.$store.commit("setLogo", url);

          if (this.datoLogin.id == this.datos.id) {
            sessionStorage.ruta_avatar_persona = res.data.uri;
            sessionStorage.avatar_persona = res.data.nombreArchivo;
          }
          this.loadMain();
          // this.setEnviarMens({tipo:"S", mensaje: `Imagen subida correctamente`, tiempo:null})
        })
        .catch(function (e) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error en Subir Imagen`+e,
            tiempo: null,
          });
        });
    },

    ///    SUBIR LOGO AVATAR PERSONA      ///
    /////////////////////////////////////////
    // contenedor del avatar del colegio
    pickAvatar() {
      // activar imput tipo file
      this.$refs.imageAvatar.click();
    },

    // Seleccion del archivo por el usuario
    onFileAvatar(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      // crea imagen temporar para visualizar
      this.createImageAvatar(files[0]);

      if (files[0] !== undefined) {
        this.imageSaveAvatar = files[0]; // this is an image file that can be sent to server...
      }
    },

    // funcion para crear una imagen temporal
    createImageAvatar(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.previewImgAvatar = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    //------------eliminar usuario -------------
    async deleteUsuario(id) {
      this.confirm.id = id;
      this.confirm.title = "¿Está seguro de borrar este registro?";
      this.confirm.active = true;
    },
    async deleted() {
      //console.log("deleting.....");
      await axios
        .delete("/sistema/usuarioManager/" + this.confirm.id)
        .then((res) => {
          if (res.data.messageT == this.$states.success) {
            this.loadMain();
            this.clear_confirm();
          }
          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: res.data.message,
            tiempo: 6000,
          });
        });
    },

    async getQuery() {
      try {
        let sesion = sessionStorage;
        let response = await axios.get(
          "/sistema/usuarioManager/getQuery/" + sesion.id_colegio
        );
        //console.log(`Datos Query : ${JSON.stringify(response.data.pais)} `)
        this.Colegio = response.data.colegio;
        this.TipoDocumentos = response.data.tipoDocumento;
        this.Paises = response.data.pais;
        this.Ubicacion1 = response.data.ubicacion1;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async getAllColegios() {
      await axios
        .get("/manager/colegio/colegiosPadres")
        .then((response) => {
          this.colegios = response.data.map((c) => {
            c.id = c.id.toString();
            return c;
          });
        })
        .catch((e) => {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${e.error}`,
            tiempo: null,
          });
          //console.log(e);
        });
    },

    async loadUbicacion1(id) {
      //console.log(` load Ubicacion1 ${id}`)
      try {
        let response = await axios.get("/mantenimiento/ubicacion1/" + id);
        this.Ubicacion1 = response.data;
      } catch (error) {
        // console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //-------obtener provincias del departamento
    async loadUbicacion2(id) {
      //console.log(` load Ubicacion2 ${id}`)
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id + "");
        this.Ubicacion2 = response.data;
      } catch (error) {
        // console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //-------obtener provincias del departamento
    async loadUbicacion3(id) {
      //console.log(` load Ubicacion3 ${id}`)
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id + "");
        this.Ubicacion3 = response.data;
        //this.datos.id_ubicacion3 = null
      } catch (error) {
        // console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //-------obtener perfil segun el colegio
    async loadPerfil(id) {
      //console.log(` load Ubicacion3 ${id}`)
      try {
        let response = await axios.get(
          `/sistema/usuario/getPerfil/colegio/${id}`
        );
        this.Perfil = response.data;
      } catch (error) {
        // console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getPerfiles(id) {
      try {
        let response = await axios.get(
          `/sistema/usuario/getPerfil/colegio/${id}`
        );
        this.perfiles = [
          { id: "todos", descripcion_perfil: "Todos" },
          ...response.data,
        ];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async cargarLicenciaTipo(perfil) {
      try {
        let params = `/sistema/usuarioManager/perfilLicenciaTipo/colegio/${this.datoLogin.id_colegio}/perfil/${perfil}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);
        this.LicenciaTipo = response.data;
      } catch (error) {
        // console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async cargarLicencia() {
      // this.setEnviarMens({tipo:"W", mensaje: `Cargar Lincencia`, tiempo:null})

      try {
        let params = `/sistema/usuarioManager/licenciaDisponibles/licenciaTipo/${this.datos.id_licencia_tipo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);
        this.Licencia = response.data;
      } catch (error) {
        // console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // validaciones
    //#############Solo numeros
    restrictCharsNumeros: function ($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },

    // restrictCharsLetras1
    //#############Solo letras
    restrictCharsLetras: function ($event) {
      const pattern = new RegExp("^[A-Z]+$", "i");
      if (
        $event.charCode === 32 ||
        pattern.test($event.key)
        ///"^[a-zA-Z ]+$" /.test($event.key)
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
  },

  destroyed() {},
};
</script>

<style scoped>
.fondo_add_img {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  cursor: pointer;
  cursor: hand;
  border: 4px solid #fff;
  border-color: #474545;
  color: #524f4f;
}

.fondo_add_img:hover {
  border-color: #b3b3b3;
  color: #b3b3b3;
}

.fondo_img {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  cursor: pointer;
  cursor: hand;
  border: 4px solid #fff;
  border-color: #d9d9d9;
  color: #d9d9d9;
  width: 180px;
  height: 180px;
}

.tam_img_thumb {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview {
  height: 170px !important;
  padding: 5px;
  border-radius: 2px;
  background: #fff;
  max-width: 200px;
}
</style>